import { selectRoles } from "../store/selectors";
import { getStore } from "../store/store";
import { USER_ROLE } from "./constants";

export enum VIEW_MODE {
    SITE = 'screen/site',
    PLANNER = 'screen/planner',
    VESSEL = 'screen/vessel'
}

export const viewMode = {
    [VIEW_MODE.SITE]: { id: VIEW_MODE.SITE, name: 'Site mode' },
    [VIEW_MODE.PLANNER]: { id: VIEW_MODE.PLANNER, name: 'Planner mode' },
    [VIEW_MODE.VESSEL]: { id: VIEW_MODE.VESSEL, name: 'Vessel mode' },
}

export const viewModes = [
    viewMode[VIEW_MODE.SITE],
    viewMode[VIEW_MODE.PLANNER],
    viewMode[VIEW_MODE.VESSEL],
]

const prefix = {
    planOp: 'plan_operation/',
    overview: 'overview/',
    dashboard: 'dashboard/',
    messenger: 'messenger/',
    opDetail: 'op_detail/',
    opSetting: 'op_setting',

    operation: 'operation/',
    checklist: 'checklist/',
    combineTreatment: 'combine_treatment/',
    operation_task_builder: 'operation_task_builder/',
    route: 'route/',
    vessel: 'vessel/',
    weather: 'weather/',
    user: 'user/',
    tenant: 'tenant/',
    factory: 'factory/',
    disease: 'disease/',
    preference: 'preference/',
    global: 'global/',
    vesselSide: 'vessel_side/',
    subscribe_email: 'subscribe_email/',
    location: 'location/',
    equipment: 'equipment/',
    site: 'site/',
    biologyOverview: "biology_overview/",
    vesselOverview: "vessel_overvview/"
}


const PLAN_OP = {
    VIEW: prefix.planOp + 'view',
    AUTO_PLAN: prefix.planOp + 'auto',
    DRAG_PLAN: prefix.planOp + 'drag_plan',
    PLAN_MENU: prefix.planOp + 'plan_menu',

    BIOLOGY_TAB: prefix.planOp + 'biology_tab',
    LOCATION_TAB: prefix.planOp + 'location_tab',
    SERVICE_REQUEST_TAB: prefix.planOp + 'service_request_tab',
    STHP_TAB: prefix.planOp + 'sthp_tab',
    SMOLT_TAB: prefix.planOp + 'smolt_tab',
    CANCEL_TAB: prefix.planOp + 'cancel_tab',

    EXTERNAL_SITE: prefix.planOp + 'external_site',

    VESSEL_MENU: prefix.planOp + 'vessel_menu',
    OP_MENU: prefix.planOp + 'op_menu',

    CREATE_OP: prefix.planOp + 'create_op',
    UPDATE_OP: prefix.planOp + 'update_op',
    CONTRACT: prefix.planOp + 'contract',
    AVAILABLE_TIME: prefix.planOp + 'available_time',

    CLEAR: prefix.planOp + 'clear',
    EXPORT_FILE: prefix.planOp + 'export_file',
    SPOT_VESSEL: prefix.planOp + 'spot_vessel',
    SAVE: prefix.planOp + 'save',
    SEND: prefix.planOp + 'send',
}

const OVERVIEW = {
    VIEW: prefix.overview + 'view',
    VESSEL_MENU: prefix.overview + 'vessel_menu',
    OP_MENU: prefix.overview + 'op_menu',
    UPDATE_OP: prefix.planOp + 'update_op',
}

const DASHBOARD = {
    VIEW: prefix.dashboard + 'view',
    LEFT_CONTROL: prefix.dashboard + 'left_control',
    TOP_CONTROL: prefix.dashboard + 'top_control',
    RIGHT_CONTROL: prefix.dashboard + 'right_control',
    SEARCH: prefix.dashboard + 'search',
    TRACKING_VESSEL: prefix.dashboard + 'tracking_vessel',
    MAP_STYLE: prefix.dashboard + 'map_style',
}

const MESSENGER = {
    VIEW: prefix.messenger + 'view',
    USER: prefix.messenger + 'user',
    OPERATION: prefix.messenger + 'operation',
}

const OP_DETAIL = {
    VIEW: prefix.opDetail + 'view',
    CHECKLIST_VIEW: prefix + 'checklist/view',
    CHECKLIST_UPDATE: prefix + 'checklist/update',
    UPDATE: prefix.opDetail + 'update',
}

const OPERATION = {
    CREATE: prefix.operation + 'create',
    UPDATE: prefix.operation + 'update',
    DELETE: prefix.operation + 'delete',
}

const CHECKLIST = {
    VIEW: prefix.checklist + 'view',
    CREATE: prefix.checklist + 'create',
    UPDATE: prefix.checklist + 'update',
    DELETE: prefix.checklist + 'delete'
}

const COMBINE_TREATMENT = {
    VIEW: prefix.combineTreatment + 'view',
    CREATE: prefix.combineTreatment + 'create',
    UPDATE: prefix.combineTreatment + 'update',
    DELETE: prefix.combineTreatment + 'delete',
    GLOBAL: prefix.combineTreatment + 'global',
}

const OPERATION_TASK_BUILDER = {
    VIEW: prefix.operation_task_builder + 'view',
    CREATE: prefix.operation_task_builder + 'create',
    UPDATE: prefix.operation_task_builder + 'update',
    DELETE: prefix.operation_task_builder + 'delete',
    GLOBAL: prefix.operation_task_builder + 'global',
}

const ROUTE = {
    VIEW: prefix.route + 'view',
    CREATE: prefix.route + 'create',
    UPDATE: prefix.route + 'update',
    DELETE: prefix.route + 'delete'
}

const VESSEL = {
    VIEW: prefix.vessel + 'view',
    CREATE: prefix.vessel + 'create',
    UPDATE: prefix.vessel + 'update',
    DELETE: prefix.vessel + 'delete',
    COST_INFO_UPDATE: prefix.vessel + 'cost_info_update',
    CONFIGURATION: prefix.vessel + 'configuration'
}

const WEATHER = {
    VIEW: prefix.weather + 'view',
    CREATE: prefix.weather + 'create',
    UPDATE: prefix.weather + 'update',
    DELETE: prefix.weather + 'delete'
}

const USER = {
    VIEW: prefix.user + 'view',
    CREATE: prefix.user + 'create',
    UPDATE: prefix.user + 'update',
    DELETE: prefix.user + 'delete',
}

const TENANT = {
    VIEW: prefix.tenant + 'view',
    CREATE: prefix.tenant + 'create',
    UPDATE: prefix.tenant + 'update',
    DELETE: prefix.tenant + 'delete',
    GENERATE_SITES: prefix.tenant + 'generate-sites',
}

const FACTORY = {
    VIEW: prefix.factory + 'view',
    CREATE: prefix.factory + 'create',
    UPDATE: prefix.factory + 'update',
    DELETE: prefix.factory + 'delete'
}

const DISEASE = {
    VIEW: prefix.disease + 'view',
    CREATE: prefix.disease + 'create',
    UPDATE: prefix.disease + 'update',
    DELETE: prefix.disease + 'delete'
}

const PREFERENCE = {
    VIEW: prefix.preference + 'view',
    PLAN: prefix.preference + 'plan',
    HARVEST_CUSTOMIZE: prefix.preference + 'harvest_customize',
    OP_CERTAIN: prefix.preference + 'op_certain',
    WORK_TIME: prefix.preference + 'work_time',
    CONFIGURE_PLAN: prefix.preference + 'config_plan',
    VESSEL_APP: prefix.preference + 'vessel_app',
    MODE: prefix.preference + 'mode',
}

const SUBSCRIBE_EMAIL = {
    VIEW: prefix.subscribe_email + 'view',
    OPERATION: prefix.subscribe_email + 'op',
    VESSEL: prefix.subscribe_email + 'vessel',
}

const GLOBAL = {
    SEARCH: prefix.global + 'search',
    SETTING: prefix.global + 'setting',
}

const VESSEL_SIDE = {
    UPDATE: prefix.vesselSide + 'update'
}

const OP_SETTING = {
    VIEW: prefix.opSetting + 'view',
    CREATE: prefix.opSetting + 'create',
    UPDATE: prefix.opSetting + 'update',
    DELETE: prefix.opSetting + 'delete',
}

const EQUIPMENT = {
    VIEW: prefix.equipment + 'view',
    CREATE: prefix.equipment + 'create',
    UPDATE: prefix.equipment + 'update',
    DELETE: prefix.equipment + 'delete',
}

const LOCATION = {
    VIEW: prefix.location + 'view',
    CREATE: prefix.location + 'create',
    UPDATE: prefix.location + 'update',
    DELETE: prefix.location + 'delete',
}

const SITE = {
    VIEW: prefix.site + 'view',
    CREATE: prefix.site + 'create',
    UPDATE: prefix.site + 'update',
    DELETE: prefix.site + 'delete',
}

const BIOLOGY_OVERVIEW = {
    VIEW: prefix.biologyOverview + 'view',
    UPDATE: prefix.biologyOverview + 'update',
}

const VESSEL_OVERVIEW = {
    VIEW: prefix.vesselOverview + 'view',
}

export const ACTION = {
    PLAN_OP,
    OVERVIEW,
    DASHBOARD,
    MESSENGER,
    OP_DETAIL,
    OPERATION,
    CHECKLIST,
    COMBINE_TREATMENT,
    OPERATION_TASK_BUILDER,
    ROUTE,
    VESSEL,
    WEATHER,
    USER,
    TENANT,
    FACTORY,
    PREFERENCE,
    GLOBAL,
    VESSEL_SIDE,
    DISEASE,
    OP_SETTING,
    SUBSCRIBE_EMAIL,
    LOCATION,
    EQUIPMENT,
    SITE,
    BIOLOGY_OVERVIEW,
    VESSEL_OVERVIEW
}

export const getViewMode = (actions: any, mode?: VIEW_MODE): VIEW_MODE | undefined => {
    if (mode && actions[mode])
        return mode;

    const data = viewModes.find(item => actions[item.id]) || { id: undefined };
    return data.id
}

const generatePermissions = (list: Record<string, string>) => Object.keys(list).reduce((rs: Record<string, boolean>, key) => {
    rs[list[key]] = true;
    return rs;
}, {});

const permissions: Record<string, Record<string, boolean>> = {
    [USER_ROLE.SUPER_ADMIN]: {
        ...generatePermissions(PLAN_OP),
        ...generatePermissions(OVERVIEW),
        ...generatePermissions(DASHBOARD),
        ...generatePermissions(MESSENGER),
        ...generatePermissions(OP_DETAIL),
        ...generatePermissions(OPERATION),
        ...generatePermissions(CHECKLIST),
        ...generatePermissions(COMBINE_TREATMENT),
        ...generatePermissions(OPERATION_TASK_BUILDER),
        ...generatePermissions(ROUTE),
        ...generatePermissions(VESSEL),
        ...generatePermissions(WEATHER),
        ...generatePermissions(USER),
        ...generatePermissions(TENANT),
        ...generatePermissions(FACTORY),
        ...generatePermissions(DISEASE),
        ...generatePermissions(PREFERENCE),
        ...generatePermissions(SUBSCRIBE_EMAIL),
        ...generatePermissions(GLOBAL),
        ...generatePermissions(VESSEL_SIDE),
        ...generatePermissions(OP_SETTING),
        ...generatePermissions(LOCATION),
        ...generatePermissions(EQUIPMENT),
        ...generatePermissions(SITE),
        ...generatePermissions(BIOLOGY_OVERVIEW),
        ...generatePermissions(VESSEL_OVERVIEW),
        [VIEW_MODE.PLANNER]: true,
        [VIEW_MODE.VESSEL]: true,
        [VIEW_MODE.SITE]: true,
    },
    [USER_ROLE.ADMIN]: {
        ...generatePermissions(PLAN_OP),
        ...generatePermissions(OVERVIEW),
        ...generatePermissions(DASHBOARD),
        ...generatePermissions(MESSENGER),
        ...generatePermissions(OP_DETAIL),
        ...generatePermissions(OPERATION),
        ...generatePermissions(CHECKLIST),
        ...generatePermissions(COMBINE_TREATMENT),
        ...generatePermissions(OPERATION_TASK_BUILDER),
        ...generatePermissions(ROUTE),
        ...generatePermissions(WEATHER),
        ...generatePermissions(USER),
        ...generatePermissions(FACTORY),
        ...generatePermissions(DISEASE),
        ...generatePermissions(PREFERENCE),
        ...generatePermissions(SUBSCRIBE_EMAIL),
        ...generatePermissions(GLOBAL),
        ...generatePermissions(VESSEL_SIDE),
        ...generatePermissions(OP_SETTING),
        ...generatePermissions(LOCATION),
        ...generatePermissions(EQUIPMENT),
        ...generatePermissions(SITE),
        ...generatePermissions(BIOLOGY_OVERVIEW),
        ...generatePermissions(VESSEL_OVERVIEW),
        [VESSEL.VIEW]: true,
        [VESSEL.UPDATE]: true,
        [VESSEL.CREATE]: true,
        [VESSEL.DELETE]: true,
        [VIEW_MODE.PLANNER]: true,
        [VIEW_MODE.VESSEL]: true,
        [VIEW_MODE.SITE]: true,
    },
    [USER_ROLE.CUSTOMER]: {
        ...generatePermissions(PLAN_OP),
        ...generatePermissions(OVERVIEW),
        ...generatePermissions(DASHBOARD),
        ...generatePermissions(MESSENGER),
        ...generatePermissions(OP_DETAIL),
        ...generatePermissions(OPERATION),
        ...generatePermissions(CHECKLIST),
        ...generatePermissions(COMBINE_TREATMENT),
        [COMBINE_TREATMENT.VIEW]: true,
        [COMBINE_TREATMENT.CREATE]: true,
        [COMBINE_TREATMENT.UPDATE]: true,
        [COMBINE_TREATMENT.DELETE]: true,
        [OPERATION_TASK_BUILDER.VIEW]: true,
        [OPERATION_TASK_BUILDER.CREATE]: true,
        [OPERATION_TASK_BUILDER.UPDATE]: true,
        [OPERATION_TASK_BUILDER.DELETE]: true,
        [VESSEL.VIEW]: true,
        [VESSEL.COST_INFO_UPDATE]: true,
        ...generatePermissions(ROUTE),
        ...generatePermissions(WEATHER),
        [FACTORY.VIEW]: true,
        ...generatePermissions(DISEASE),
        ...generatePermissions(PREFERENCE),
        ...generatePermissions(OP_SETTING),
        ...generatePermissions(LOCATION),
        ...generatePermissions(SITE),
        ...generatePermissions(BIOLOGY_OVERVIEW),
        ...generatePermissions(VESSEL_OVERVIEW),
        [SUBSCRIBE_EMAIL.VIEW]: true,
        [SUBSCRIBE_EMAIL.OPERATION]: true,
        [GLOBAL.SEARCH]: true,
        [GLOBAL.SETTING]: true,
        [VIEW_MODE.PLANNER]: true,
    },
    [USER_ROLE.VESSEL_OWNER]: {
        ...generatePermissions(PLAN_OP),
        ...generatePermissions(OVERVIEW),
        ...generatePermissions(DASHBOARD),
        ...generatePermissions(MESSENGER),
        [OP_DETAIL.VIEW]: true,
        [OP_DETAIL.CHECKLIST_VIEW]: true,
        [OP_DETAIL.CHECKLIST_UPDATE]: true,
        ...generatePermissions(VESSEL_SIDE),
        ...generatePermissions(VESSEL_OVERVIEW),
        [COMBINE_TREATMENT.VIEW]: true,
        [COMBINE_TREATMENT.CREATE]: true,
        [COMBINE_TREATMENT.UPDATE]: true,
        [COMBINE_TREATMENT.DELETE]: true,
        [OPERATION_TASK_BUILDER.VIEW]: true,
        [OPERATION_TASK_BUILDER.CREATE]: true,
        [OPERATION_TASK_BUILDER.UPDATE]: true,
        [OPERATION_TASK_BUILDER.DELETE]: true,
        [VESSEL.VIEW]: true,
        [VESSEL.UPDATE]: true,
        [VESSEL.CREATE]: true,
        [VESSEL.DELETE]: true,
        [VESSEL.COST_INFO_UPDATE]: true,
        [OPERATION.UPDATE]: true,
        [PREFERENCE.VIEW]: true,
        [PREFERENCE.MODE]: true,
        [SUBSCRIBE_EMAIL.VIEW]: true,
        [SUBSCRIBE_EMAIL.VESSEL]: true,
        [GLOBAL.SEARCH]: true,
        [GLOBAL.SETTING]: true,
        [VIEW_MODE.VESSEL]: true,
        [VIEW_MODE.PLANNER]: true,
    },
    [USER_ROLE.VESSEL_VIEWER]: {
        [DASHBOARD.VIEW]: true,
        [DASHBOARD.TOP_CONTROL]: true,
        [DASHBOARD.TRACKING_VESSEL]: true,
        [DASHBOARD.MAP_STYLE]: true,
        ...generatePermissions(MESSENGER),
        [OP_DETAIL.VIEW]: true,
        [OP_DETAIL.CHECKLIST_VIEW]: true,
        [OP_DETAIL.CHECKLIST_UPDATE]: true,
        [OVERVIEW.VIEW]: true,
        [GLOBAL.SETTING]: true,
        [PREFERENCE.VIEW]: true,
        [PREFERENCE.MODE]: true,
        [VIEW_MODE.VESSEL]: true
    },
    [USER_ROLE.CREW]: {
        ...generatePermissions(OVERVIEW),
        [DASHBOARD.VIEW]: true,
        [DASHBOARD.TOP_CONTROL]: true,
        [DASHBOARD.TRACKING_VESSEL]: true,
        [DASHBOARD.MAP_STYLE]: true,
        ...generatePermissions(MESSENGER),
        [OP_DETAIL.VIEW]: true,
        [OP_DETAIL.CHECKLIST_VIEW]: true,
        [OP_DETAIL.CHECKLIST_UPDATE]: true,
        ...generatePermissions(VESSEL_SIDE),
        [OPERATION.UPDATE]: true,
        [GLOBAL.SETTING]: true,
        [PREFERENCE.VIEW]: true,
        [PREFERENCE.PLAN]: true,
        [PREFERENCE.OP_CERTAIN]: true,
        [PREFERENCE.MODE]: true,
        [VIEW_MODE.VESSEL]: true
    },
    [USER_ROLE.SITE_MANAGER]: {
        ...generatePermissions(DASHBOARD),
        ...generatePermissions(MESSENGER),
        [OP_DETAIL.VIEW]: true,
        [OP_DETAIL.CHECKLIST_VIEW]: true,
        [OP_DETAIL.CHECKLIST_UPDATE]: true,
        ...generatePermissions(SITE),
        ...generatePermissions(BIOLOGY_OVERVIEW),
        [OVERVIEW.VIEW]: true,
        [GLOBAL.SETTING]: true,
        [SUBSCRIBE_EMAIL.VIEW]: true,
        [VIEW_MODE.SITE]: true,
    },
    [USER_ROLE.FACTORY_MANAGER]: {
        [OVERVIEW.VIEW]: true,
        ...generatePermissions(DASHBOARD),
        ...generatePermissions(MESSENGER),
        [OP_DETAIL.VIEW]: true,
        [OP_DETAIL.CHECKLIST_VIEW]: true,
        [OP_DETAIL.CHECKLIST_UPDATE]: true,
        [SUBSCRIBE_EMAIL.VIEW]: true,
        [VIEW_MODE.PLANNER]: true,
        [GLOBAL.SETTING]: true,
    },
    [USER_ROLE.READ_ONLY]: {
        [DASHBOARD.VIEW]: true,
        [DASHBOARD.LEFT_CONTROL]: true,
        [DASHBOARD.TOP_CONTROL]: true,
        [DASHBOARD.RIGHT_CONTROL]: true,
        [OVERVIEW.VIEW]: true,

        [PLAN_OP.VIEW]: true,
        [PLAN_OP.BIOLOGY_TAB]: true,
        [PLAN_OP.LOCATION_TAB]: true,
        [PLAN_OP.STHP_TAB]: true,
        [PLAN_OP.SMOLT_TAB]: true,

        [BIOLOGY_OVERVIEW.VIEW]: true,
        [MESSENGER.VIEW]: true,
        [MESSENGER.USER]: true,
        [VESSEL.VIEW]: true,
        [PREFERENCE.VIEW]: true,
        [GLOBAL.SETTING]: true,
        [VIEW_MODE.PLANNER]: true,
        [OP_DETAIL.VIEW]: true,
        [OP_DETAIL.CHECKLIST_VIEW]: true,
    }
}

export function generateActions(roles: USER_ROLE[] = []) {
    return roles.reduce((rs: any, item) => ({ ...rs, ...permissions[item] || {} }), {})
}

export function checkApprovePermission() {
    const roles = selectRoles(getStore());
    const allow = new Set([USER_ROLE.SUPER_ADMIN, USER_ROLE.ADMIN, USER_ROLE.VESSEL_OWNER, USER_ROLE.CUSTOMER]);
    return roles.some((role: USER_ROLE) => allow.has(role));
}